import { LegalFormEnum, LegalFormEnumMap } from '~/src/models/enums/legal-form.enum';
import { INDIVIDUAL } from '~/src/layouts/clients-request-layout/clients-request-layout.constants';
import { FormVariant } from '~/src/context/client-request-form/client-request-form.types';
import type { ProductsDictionaryMappedInterface } from '~/src/repositories/cms/types/cms.types';

export const determineProductAvailability = (
    dataProducts: {
        [key: string]: ProductsDictionaryMappedInterface[];
    },
    productCode: string,
) => {
    const dataProductWithoutCategories = [];
    for (const [_, value] of Object.entries(dataProducts)) {
        value && dataProductWithoutCategories.push(...value);
    }
    return dataProductWithoutCategories.some((product) => product.code === productCode);
};

export const setClientType = (
    currentVariant: FormVariant,
    opf:
        | {
              fullName: string;
              shortName: string;
          }
        | null
        | undefined,
) => {
    if (currentVariant === 'selfEmployed') {
        return LegalFormEnumMap[LegalFormEnum.SELF_EMPLOYEE];
    } else if (currentVariant === 'default') {
        return opf && opf.shortName === INDIVIDUAL
            ? LegalFormEnumMap[LegalFormEnum.INDIVIDUAL_ENTREPRENEUR]
            : LegalFormEnumMap[LegalFormEnum.LEGAL_ENTITY];
    }
};
